<template>
  <div class="employeeIndex">
    <div class="flex-row flex-nowrap page-search-block">
      <el-form :model="filters.search" label-width="120px" label-position="right" inline>
        <el-form-item prop="name" label="姓名：" >
          <el-input v-model="filters.search.name" placeholder="请输入" ></el-input>
        </el-form-item>
        <!-- <el-form-item  prop="zjhm" label="证件号码：" >
          <el-input v-model="filters.search.zjhm" placeholder="请输入" ></el-input>
        </el-form-item> -->
        <!-- <el-form-item  prop="zjhm" label="联系电话：" >
          <el-input v-model="filters.search.lxdh" placeholder="请输入" ></el-input>
        </el-form-item> -->
        <!--工作单位、社会信用代码、人员类型、入职日期、离职日期-->
        <!--,'certType','zjhm','company','socialCreditCode','staffType','dwbgdzQbm','hireDate','fdLxdh'-->
        <el-form-item  prop="company" label="工作单位：" >
          <el-input v-model="filters.search.company" placeholder="请输入" ></el-input>
        </el-form-item>
        <el-form-item  prop="socialCreditCode" label="社会信用代码：" >
          <el-input v-model="filters.search.socialCreditCode" placeholder="请输入" ></el-input>
        </el-form-item>
        <el-form-item  prop="staffType" label="人员类型："  >
          <el-select v-model="filters.search.staffType" filterable placeholder="请选择" >
            <el-option v-for="item in selOptions.staffType" :key="item.name" :label="item.value" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="hireDate" label="入职日期：" >
          <el-date-picker
            v-model="filters.search.hireDate"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item  prop="leaveDate" label="离职日期：" >
          <el-date-picker
            v-model="filters.search.leaveDate"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>

        <div class="search-wrap-block">
          <el-button size="small" type="primary" icon="Search" @click="handleSearch()">搜 索</el-button>
          <el-button size="small"  type="primary" icon="RefreshRight" @click="resetFilter()">重 置</el-button>
        </div>
      </el-form>
    </div>
    <div class="flex-row flex-nowrap flex-block m-b-xs page-operate-block" style="justify-content: flex-end; margin-bottom: 8px;">
      <i
        class="fa icon-eye"
        :class="[hiddenNumberBol ? 'fa-eye-slash' : 'fa-eye']"
        style="margin-right: 16px;"
        @click="switchNumberHiddenOrShow()"
      ></i>
      <el-popover placement="bottom" trigger="click" popper-class="r-popover">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <br />
        <el-checkbox v-for="(column, index) in tableColumn" v-model="column.visible" :key="index" @change="_checkChange">{{column.label}}</el-checkbox>
        <el-button  class="primary-btn-g m-r-xs" size="small" slot="reference"  name="dataSetting" style="margin-right: 10px;">数据项</el-button>
      </el-popover>
      <el-button v-if="isShowBtn('add')" class="primary-btn-g m-r-xs" icon="Plus" slot="reference"  name="dataSetting" @click="handleEdit('add')">新增</el-button>
      <el-button v-if="isShowBtn('update')" class="primary-btn-g m-r-xs" slot="reference" icon="Edit"  name="dataSetting" :disabled="options.selection.length!=1" @click="handleEdit('edit')">编辑</el-button>
      <el-button v-if="isShowBtn('delete')" class="danger-btn-g" icon="el-icon-delete" slot="reference"  @click="handlePatchDelete(true)" :disabled="options.selection.length<1">删除</el-button>
    </div>
    <r-table
      :ref="tableVarity"
      :columns="tableColumn"
      :dataSource="tableData"
      :options="options"
      :pagination="pagination"
      @current-change="handlePageChange"
      @row-click="handleRowClick"
    ></r-table>
    <!--查看-->
    <!-- <RModal :title="detailTitle" v-model="detailModal" @close="detailModal = false" :width="'60%'"> -->
    <Modal :modalTitle="detailTitle" modalId="detailModalId" class="smallModalDialog employee-dialog" @close="detailModal = false" :width="'60%'">
        <detail-view v-if="detailType=='show'" :detailModal="detailModal" :detailData="detailData" :selOptions="selOptions"></detail-view>
        <edit-view v-else-if="detailType=='add' || detailType=='edit'" :detailType="detailType" :detailModal="detailModal" :detailData="detailData" :selOptions="selOptions" @submitSuccess="submitSuccess" @closeModel="closeModel">
        </edit-view>
    </Modal>
    <!-- </RModal> -->
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapActions, mapGetters ,mapState} from 'vuex'
  import RModal from '@/components/common/RModal'
  import RTable from '@/components/common/RTable'
  import tableMix from '@/components/common/tableListMixin.js'
  import checkMix from '@/components/common/checkAll.js'
  import detailView from './detailView'
  import editView from './editView'
  import moment from 'moment'
  import {formatTime} from "@/utils/index.js";
export default {
  name: 'baseInfoEmployee',
  mixins: [tableMix, checkMix],
  components: { RTable ,detailView,RModal,editView},
  data() {
    let detailKeys = ['name','certType','zjhm','company','socialCreditCode','staffType','dwbgdzQbm','hireDate','leaveDate','lxdh','staffType','hireDate','leaveDate']
    let searchData = {}
    detailKeys.map((key)=>{
      searchData[key] = ''
    })
    return {
      perms: [],
      detailModal:false,
      detailType:'show',
      detailTitle:'详情',
      uploadModal:false,
      downloadUrl:'',
      detailData:{},
      deleteUrl:'CLEAN.CLEANER.DELETE',
      areUOk: false,
      tableVarity: 'baseinfo_employee_table',
      tableColumn: [],
      tableData: [],
      selOptions:{certType:[],staffType:[],},
      selOptionMaps:{certType:{},staffType:{}},
      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        height: 'calc(100vh - 295px)',
        mutiSelect: true,
        selection: [],
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      },
      // 查询参数
      filters: { search: searchData },
      hiddenNumberBol: true,
    }
  },

  watch: {
    detailModal(val) {
      if(val){
        $('#detailModalId').modal({ backdrop: 'static', show: true })
      }else{
        $('#detailModalId').modal('hide')
      }
    },
  },
  created() {
    this.perms = 'perms' in localStorage && localStorage.perms !== '' ? JSON.parse(localStorage.perms) : []
    this.initTableColumns()
    this.getDictData('certType', 'certType')
    this.getDictData('personWorkType', 'staffType')
    this.getDataList()
  },
  mounted() {

  },
  methods: {
    ...mapActions(['importUpload']),
    // 是否显示这个按钮
    isShowBtn(perm) {
      return true;
      let url = window.location.pathname.substr(5)
      let len = this.perms.length
      let pid = ''
      for (let i = 0; i < len; i++) {
        if (this.perms[i].url == url) {
          pid = this.perms[i].id
        }
      }
      for (let i = 0; i < len; i++) {
        if (this.perms[i].pid == pid && this.perms[i].perm == perm) {
          return true
        }
      }

      return false
    },
    // 获取字典数据
    getDictData(types, prop) {
      let url = 'RESOURCE.GET_MULTI_LIST'
      this.fetchData({
        url,
        method: 'get',
        params: {
          types,
          // start: 0,
          // size: 1000,
          // toExcel: false
        }
      }).then( res => {
        console.log(res);
        this.selOptions[prop] = res[types];
        let maps = {}
        res[types].map((obj)=>{
          maps[obj.name] = obj.value
        })
        this.selOptionMaps[prop] = maps
      })

    },
    // 查询列表数据
    getQuery() {
      this.options.loading = true
      let params = this.getQueryParams2();
      delete params.toExcel;
      const query = Object.entries(this.filters.search).filter(([key, value]) => value).reduce((acu, [key, value]) => {
        if(['hireDate', 'leaveDate'].includes(key)) value = formatTime(value, 'yyyy-MM-dd');
        acu[key] = value;
        return acu;
      }, {});

      let url = 'CLEAN.CLEANER.GET_LIST'
      this.fetchData({
        url,
        method: 'get',
        params: {
          pageNumber: params.pageNumber,
          pageSize: params.pageSize,
          ...query,
        },
      })
        .then((res) => {
          this.options.loading = false
          if (this.toExcel == true) {
            if (!res || !res.data) {
              this.$message.error('操作失败！')
            } else {
              window.location.href = res.data
            }
            this.toExcel = false
            return
          }

          if (!res || !res.data) {
            this.tableData = []
            this.pagination.total = 0
          } else {
            this.tableData = this.parseTableData(res.data);
            this.pagination.total = res.count;
            this.hiddenNumberBol = true;
          }
          this.originalTableData = JSON.parse(JSON.stringify(this.tableData));
        })
        .catch((err) => {
          console.log(err, 'errorInfo')
        })
        .finally(() => {
          this.options.loading = false
          this.toExcel = false
        })
    },

    parseTableData(data) {
      if (!data || !Array.isArray(data)) return [];
      data.forEach(item => {
        const areaCode = item.areaCode;
        if(areaCode){
          item.areaCode = [
            `${areaCode.slice(0, 2)}0000000000`,
            `${areaCode.slice(0, 4)}00000000`,
            `${areaCode.slice(0, 6)}000000`,
          ]
        }
        item['xmParse'] = (item['name'] && item['name'].substr(0, 1) + '**') || ''; // 姓名
        item['lxdhParse'] = (item['lxdh'] && item['lxdh'].substr(0, 3) + '****' + item['lxdh'].substr(-4)) || ''; // 联系电话
        item['zjhmParse'] = (item['zjhm'] && item['zjhm'].substr(0, 6) + '********' + item['zjhm'].substr(-4)) || ''; // 证件号码
      });
      return data;
    },

    // 初始化自定义表头
    initTableColumns() {

      let columns = [
        { prop: 'name', label: '姓名', visible: true, minWidth: 160, isInput: true },
        { prop: 'certType', label: '证件种类', visible: true, minWidth: 160, isSelect: true  },
        { prop: 'certCode', label: '证件号码', visible: true, minWidth: 160, isInput: true },
        { prop: 'phone', label: '联系电话', visible: true, minWidth: 160, isInput: true },
        { prop: 'staffTypeName', label: '人员类型', visible: true, minWidth: 160, isSelect: true },
        { prop: 'company', label: '工作单位', visible: true, minWidth: 160, isInput: true },
        { prop: 'companyAddress', label: '工作地', visible: true, minWidth: 250, isInput: true },
        { prop: 'socialCreditCode', label: '社会信用代码', visible: true, minWidth: 160, isInput: true  },
        { prop: 'hireDate', label: '入职日期', visible: true, minWidth: 160, isInput: false },
        { prop: 'leaveDate', label: '离职日期', visible: true, minWidth: 160, isInput: false },
        { prop: 'createTime', label: '登记时间', visible: true, minWidth: 160, isInput: false },
        { prop: 'updateTime', label: '更新时间', visible: true, minWidth: 160, isInput: false },
      ]

      columns.forEach((item) => {
        if(item.prop=='name'){
          item.render =  (row, index, column)=>{
            return <a  onClick={this.handleShowDetail.bind(this, row)}>{row[column.prop]}</a>;
          }
        }else if(item.prop=='staffType'){
          item.render =  (row, index, column)=>{
            return <span>{this.selOptionMaps.staffType[row['staffType']]}</span>;
          }
        }else if(item.prop=='certType'){
          item.render =  (row, index, column)=>{
            return <span>{this.selOptionMaps.certType[row['certType']]}</span>;
          }
        }
      })

      this.tableColumn = columns
    },
    handleShowDetail(row) {
      this.detailData = {...row}
      this.$nextTick(()=>{
        this.detailType = 'show'
        this.detailTitle = '详情'
        this.detailModal = true
      })
    },
    handleEdit(detailType){
      this.$nextTick(()=>{
        this.detailType = detailType
        this.detailTitle = detailType=='add'?'新增':'编辑'
        this.detailModal = true
        if(detailType=='edit' && this.options.selection.length){
          this.detailData = {...this.options.selection[0]}
        }else{
          this.detailData = {}
        }
      })
    },
    submitSuccess(){
      this.detailModal=false
      this.detailType = ''
      this.getDataList()
    },
    closeModel(){
      this.detailModal=false
    },
    dataMasker(value, type = 'name'){
      if(this.hiddenNumberBol){
        if(type == 'name') return (value.substr(0, 1) + '**') || '';
        if(type == 'phone') return (value.substr(0, 3) + '****' + value.substr(-4)) || '';
        if(type == 'certCode') return (value.substr(0, 6) + '********' + value.substr(-4)) || '';
      }else{
        return value;
      }
    },
    /**
     * 切换敏感信息加密状态
     */
    switchNumberHiddenOrShow() {
      this.hiddenNumberBol = !this.hiddenNumberBol;
      this.tableData.forEach((item, index) => {
        const originalItem = this.originalTableData[index];
        item.name = this.dataMasker(originalItem.name);
        item.phone = this.dataMasker(originalItem.phone, 'phone');
        item.certCode = this.dataMasker(originalItem.certCode, 'certCode');
      });
    },
  }
}
</script>

<style lang="less" scoped>
.log-title {
  font-size: 22px;
  font-weight: 600;
}
.flex-row {
  align-items: center;
}
.employee-dialog {
  /deep/ .modal-dialog {
    top: 5% !important;
  }
}
</style>
